export default __webpack_public_path__ + "static/media/contact-1.48afce5c.svg";